export class FotoDTO {
  nomeArquivo: string;

  constructor(nomeArquivo: string) {
    this.nomeArquivo = nomeArquivo;
  }
}
